const CLASS_ACTIVE = 'is-active';

export default class GalleryModal {
    current = 0;

    static instance(){
        if(this._instance) return this._instance;
        return this._instance = new this();
    }

    constructor() {
        this.el = document.createElement('div');
        this.content = document.createElement('div');
        this.cross = document.createElement('div');
        this.left = document.createElement('div');
        this.right = document.createElement('div');
        this.el.className = 'gallery-modal';
        this.content.className = 'gallery-modal__content';
        this.cross.className = 'gallery-modal__cross';
        this.left.className = 'gallery-modal__left';
        this.right.className = 'gallery-modal__right';
        this.items = [];
        this.el.appendChild(this.content);
        this.el.appendChild(this.cross);
        this.el.appendChild(this.left);
        this.el.appendChild(this.right);
        document.body.appendChild(this.el);

        this.close = this.close.bind(this);
        this.goLeft = this.goLeft.bind(this);
        this.goRight = this.goRight.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.init();
    }

    init() {
        this.cross.addEventListener('click', this.close);
        this.left.addEventListener('click', this.goLeft);
        this.right.addEventListener('click', this.goRight);
        document.addEventListener("keydown", this.keyDown);
    }

    createItem(index, imgSrc, caption){
        const node = document.createElement('div');
        const imageNode = document.createElement('div');
        const img = document.createElement('img');
        node.className = 'gallery-modal__item';
        imageNode.className = 'gallery-modal__image';
        img.src = imgSrc, caption;

        if (caption !== null) {
            const captionNode = document.createElement('div');
            captionNode.className = 'gallery-modal__caption';
            // console.log(captionNode);
            captionNode.innerHTML = caption;
            imageNode.appendChild(captionNode);
        }

        imageNode.appendChild(img);
        node.appendChild(imageNode);
        this.content.appendChild(node);
        this.items[index] = node;
    }

    clean() {
        this.content.innerHTML = '';
        this.items = [];
    }

    open(index) {
        this.current = index;
        this.el.classList.add(CLASS_ACTIVE);
        this.items[this.current].classList.add(CLASS_ACTIVE);
    }

    close() {
        this.el.classList.remove(CLASS_ACTIVE);
        this.items[this.current].classList.remove(CLASS_ACTIVE);
    }

    goLeft() {
        let newIndex = this.current - 1;
        newIndex = newIndex < 0 ? this.items.length - 1 : newIndex;
        this.items[this.current].classList.remove(CLASS_ACTIVE);
        this.current = newIndex;
        this.items[this.current].classList.add(CLASS_ACTIVE);
    }

    goRight() {
        let newIndex = this.current + 1;
        newIndex = newIndex > this.items.length - 1 ? 0 : newIndex;
        this.items[this.current].classList.remove(CLASS_ACTIVE);
        this.current = newIndex;
        this.items[this.current].classList.add(CLASS_ACTIVE);
    }

    keyDown(e) {
        // Esc
        if (e.which === 27) {
            // console.log('Gallery Modal: Esc key pressed.');
            this.close();
        }

        // Left arrow
        if (e.which === 37) {
            this.goLeft();
        }

        // Right arrow
        if (e.which === 39) {
            this.goRight();
        }
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/components/gallery-modal.js